<template>
  <BaseLayout>
    <InnerLoading :loading="isLoading">
      <div class="flex flex-col gap-5">
        <Banner :offer="bannerOffer" @onContratar="onSelectOffer" />

        <div
          class="-mt-32 sm:mt-0 sm:flex flex-col sm:bg-white bg-transparent bg-gradient-to-b from-transparent via-black to-black sm:from-white sm:via-white sm:to-white sm:px-12 xl:px-40 2xl:px-64 px-5 py-5 sm:items-start items-center">
          <div class="flex flex-col gap-3">
            <mdn-text class="sm:text-black text-white text-4xl font-bold">Planos Claro Controle</mdn-text>
            <mdn-text class="sm:text-black text-white text-base lg:w-1/2">Planos Controle com internet para o dia a dia,
              acesso gratuito aos seus apps favoritos, ligações ilimitadas e conteúdos exclusivos.</mdn-text>
          </div>
        </div>

        <div class="py-5 px-5 sm:px-12 xl:px-40 2xl:px-64 sm:pb-10 sm:pt-0">
          <div class="flex flex-col sm:flex-row flex-grow justify-end gap-5">
            <Flicking
              :options="{ align: 'prev', renderOnlyVisible: true, iOSEdgeSwipeThreshold: 60, horizonal: true, adaptative: false, defaultIndex: 0, circular: false, bound: true, bounce: 0 }">
              <OfferComponent v-bind:id="'card-'+offer.id"  :key="offer.id" v-for="offer in showHomeCard(lists)" :is-mobile="$isMobile"
                v-bind="{ offer }" @select="onSelectOffer" @showDetails="onShowDetails" @showBenefits="onShowBenefits" />
            </Flicking>
          </div>
        </div>
      </div>

    </InnerLoading>
    <OfferDialog ref="detailsDialog" />
    <OfferDialog ref="benefitsDialog" />
  </BaseLayout>
</template>

<script type="text/javascript" src="https://cdn.jsdelivr.net/npm/es6-promise/dist/es6-promise.auto.js"></script>
<script>
import { Flicking } from '@egjs/vue-flicking'
import '@egjs/vue-flicking/dist/flicking.css'
import '@egjs/vue-flicking/dist/flicking-inline.css'
import InnerLoading from '../../components/InnerLoading'
import { setOfferMixin, loadOffersMixin } from '@/business/offers/mixins'
import OfferComponent from './Offer/Offer.vue'
import store from '@/business/store'
import { serviceBuilder as userService } from '@/business/user/service'
import { serviceBuilder as offerService } from '@/business/offers/service'
import { useHttpServiceMixin } from '@/common/use-http'
import { removeQueryParamAndAddToStore, addToStore, removeFromQueryParams } from '@/common/utils'
import { NotifyUserActionsEnum } from '@/business/http/dto/NotifyUserActionRequest'
import { SMS_MSISDN_KEY, SMS_OFFER_KEY, SMS_STORE_MSISDN_KEY, SMS_ORIGIN_KEY, SMS_STORE_ORIGIN_KEY, SHOULD_SAVE_MSISDN_AND_RECORD_ACTIONS, SHOULD_HIDE_BACK_BUTTONS, SHOULD_HIDE_SWITCH_OFFER, BEAUTH_CODE, CPF_KEY, CHANNEL_KEY } from '@/common/constants'
import OfferDialog from '../../components/OfferDialog.vue'
import Banner from '../../components/Banner.vue'
import { MdnText, Button } from 'mondrian-vue'

export default {
  name: 'page-1-step',
  mixins: [setOfferMixin, loadOffersMixin,
    useHttpServiceMixin({ userService, offerService })],
  components: { OfferComponent, InnerLoading, OfferDialog, Flicking, Button, MdnText, Banner },
  title: 'Escolha seu plano',
  data () {
    return {
      isProcessing: false
    }
  },
  async mounted () {
    const queryParams = this.$route.query || {}
    Object.entries(queryParams)
      .map(async ([key, value]) => {
        if (key.includes('utm')) {
          store.set(key, value)
          store.keep(key)
        }
        switch (key) {
          case BEAUTH_CODE: {
            this.$router.replace(removeFromQueryParams(BEAUTH_CODE, queryParams))
            if (!queryParams[CHANNEL_KEY] && !queryParams[SMS_OFFER_KEY]) {
              break
            }

            const offerId = this.$route.query[SMS_OFFER_KEY]
            const channel = this.$route.query[CHANNEL_KEY]
            const {msisdn, cpf} = await this.$userService.validateBeauth(value)
            const extra = { offerId, origin: channel }

            this.$userService.notifyUserAction(msisdn, NotifyUserActionsEnum.ACESSO, extra)

            addToStore(store, SMS_OFFER_KEY, offerId)
            addToStore(store, SMS_MSISDN_KEY, msisdn)
            addToStore(store, SMS_STORE_ORIGIN_KEY, channel)
            addToStore(store, CPF_KEY, cpf)

            try {
              this.$router.push({
                name: 'page-2-step',
                query: {
                  [SMS_OFFER_KEY]: offerId,
                  [SMS_MSISDN_KEY]: msisdn,
                  [SMS_ORIGIN_KEY]: channel,
                  [CPF_KEY]: cpf
                }
              })
            } catch (err) {
              this.$tracker.error(err)
              this.$router.push({ page: 'error-page' })
            }

            break
          }
          case SMS_MSISDN_KEY: {
            this.$router.replace(removeQueryParamAndAddToStore(store, SMS_STORE_MSISDN_KEY, value, SMS_MSISDN_KEY, queryParams))
            this.$userService.notifyUserAction(value, NotifyUserActionsEnum.ACESSO)
            break
          }
          case SMS_ORIGIN_KEY: {
            this.$router.replace(removeQueryParamAndAddToStore(store, SMS_STORE_ORIGIN_KEY, value, SMS_ORIGIN_KEY, queryParams))
            addToStore(store, SHOULD_SAVE_MSISDN_AND_RECORD_ACTIONS, true)
            break
          }
          case SMS_OFFER_KEY: {
            this.$router.replace(removeFromQueryParams(SMS_OFFER_KEY, queryParams))
            addToStore(store, SHOULD_HIDE_BACK_BUTTONS, true)
            addToStore(store, SHOULD_HIDE_SWITCH_OFFER, true)
            await this.setOffer(value)
            break
          }
        }
      })

    if (queryParams[SMS_OFFER_KEY]) {
      this.$router.push({ name: 'page-2-step' })
    }
  },
  computed: {
    lists () {
      return this.offers
    },
    isLoading () {
      return this.isOffersLoading || this.isProcessing
    },
    bannerOffer () {
      return this.offerByShowInHeaderIsTrue()
    }
  },
  methods: {
    async onSelectOffer (offer) {
      this.isProcessing = true
      this.$tracker.log('clique:selecionar-plano', 'plano-' + offer?.data.main + 'gb')
      const msisdn = await store.get(SMS_STORE_MSISDN_KEY)
      const origin = await store.get(SMS_STORE_ORIGIN_KEY)
      const extra = { offerId: offer.id, origin }
      this.$userService.notifyUserAction(msisdn, NotifyUserActionsEnum.CONTRATAR, extra)
      try {
        await this.setOffer(offer.id)
        this.$router.push({ name: 'page-2-step' })
      } catch (err) {
        this.$tracker.error(err)
        this.$router.push({ page: 'error-page' })
      }
    },

    async onShowDetails (offer) {
      const config = {
        title: `Detalhes - Claro Controle ${offer.data.full}GB`,
        bodyTitle: `${offer.data.full}GB + ${offer.shortDescription.toUpperCase()} ${offer.subDescription}`,
        textsBody: [
          { mainText: `Com esse plano, o cliente vai pagar R$${offer.price.adesao.full} na adesão diretamente no cartão de crédito. Sem fidelização. Todo mês, será debitado o valor de R$${offer.price.adesao.full} no cartão de crédito e renovado os benefícios do plano. Em caso de problema na cobrança, o cliente será avisado via SMS pelo remetente “Claro” para realizar a troca do cartão.` },
          { mainText: 'Toda a comunicação com o cliente é feita via SMS por esse mesmo remetente “Claro”. O cliente pode conferir detalhes sobre o plano, benefícios e gestão da oferta acessando na web www.minhaclaro.com.br ou pelo APP Minha Claro.' },
          { mainText: 'A velocidade de navegação a que o cliente poderá ter acesso, dependerá da tecnologia disponível na localidade (2G, 3G ou 4G) e respectiva cobertura, além do aparelho utilizado pelo cliente para acesso a internet.',
            items: [
              {
                titleItems: 'Tecnologia 4GMax',
                itemsOpt: ['- Velocidade Máxima de Download/Upload: até 5Mbps/ 512Kbps', '- Velocidade Média de Download/Upload: 2Mbps', '- Velocidade Mínima: 128 Kbps']
              },
              {
                titleItems: 'Tecnologia 3GMax',
                itemsOpt: ['- Velocidade Máxima de Download/Upload: até 1Mbps/ 128Kbps', '- Velocidade Média de Download/Upload: 650 Kbps', '- Velocidade Mínima: 128 Kbps']
              },
              {
                titleItems: 'Tecnologia 2G',
                itemsOpt: ['- Velocidade Máxima de Download/Upload: até 60Mbps/ 16Kbps', '- Velocidade Média de Download/Upload: 12 Kbps', '- Velocidade Mínima: 8 Kbps']
              }
            ]
          },
          { mainText: 'Depois de atingir a franquia de dados contratada, o usuário terá a navegação interrompida até a próxima renovação de franquia, caso deseje, poderá contratar pacote adicional através do SMS 418 ou acessando web www.minhaclaro.com.br ou pelo APP Minha Claro.' },
          { mainText: 'Estão inclusas na franquia de ligações ilimitadas as ligações para números especiais e trí-digito.' },
          { mainText: 'Não estão inclusas na franquia de ligações ilimitadas as ligações DDI, em roaming nacional através de outra Operadora e/ou em roaming internacional, bem como as ligações realizadas para serviços de repasses financeiros ou promoções, tais como chat amizade, concurso e promoções comerciais, como Secretária Claro, serviços de atendimento, 0300, 0500, dentre outras. Para realizar estas ligações é necessário a utilização de recarga.' },
          { mainText: 'Fora da área de cobertura da Claro para efetuar ligações, receber ligações a cobrar, enviar SMS e utilizar a internet será necessário a utilização de recarga.' }
      ]
      }
      await this.$refs.detailsDialog.show(config)
    },

    async onShowBenefits (offer) {
      const config = {
        title: `Benefícios - Claro Controle ${offer.data.full}GB`,
        bodyTitle: `${offer.data.full}GB + ${offer.shortDescription.toUpperCase()} ${offer.subDescription}`,
        textsBody: [
          { mainText: 'Ligações ilimitadas para qualquer operadora usando o 21. Na Claro, as ligações são ilimitadas para fixo e celular de qualquer operadora do Brasil, incluindo celulares Claro e telefone fixo Claro e Claro net fone, usando o 21. Também tem ligações ilimitadas para números especiais (exceto 0300 e 0500) e números de três dígitos.' },
          { mainText: `Internet com ${offer.data.full}GB no seu plano para você ficar conectado onde estiver. Além disso, dependendo da sua localidade, poderá usufruir da tecnologia 4GMax. Consulte a cobertura em sua região` },
          { mainText: 'Roaming Nacional com isenção das chamadas recebidas em viagem (fora do seu Estado), elas não serão cobradas e nem descontadas do seu plano. Não há custos extras em roaming nacional na área de cobertura da Claro.' },
          { mainText: 'SMS ilimitados para qualquer operadora' }
        ],
        includedApps: {
          title: "Aplicativos com assinaturas inclusas em sua oferta Skeelo",
          apps: offer.benefit.includedApps
        },
        limitedApps: {
          title: `${offer.data.apps}GB de bônus para acessar os aplicativos`,
          apps: offer.apps.limited
        }
      }
      await this.$refs.benefitsDialog.show(config)
    },

    showHomeCard (offers) {
      if (offers !== undefined) {
        return offers.filter(o => !o.hiddenHome).sort((a, b) => a.data.full - b.data.full)
      }
    },

    offerByShowInHeaderIsTrue () {
      if (this.offers !== undefined) {
        return this.offers.find(o => o.showInHeader) ?? this.offers[0]
      }
    }
  }
}
</script>
